const ValidationStatuses = {
  READY: "ready",
  VALIDATING: "validating",
  VALIDATED: "validated",
  VALIDATED_WITH_ERRORS: "validatedWithErrors",
  FAILED: "failed"
} as const;

const ALL = Object.values(ValidationStatuses);

export default { ...ValidationStatuses, ALL };
